import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { site } from '../../content/site';
import './Header.css';

/**
 * Site header. Logo + minimal anchor nav. Anchors point to sections on the
 * homepage; from a case study page they navigate home then scroll.
 */
export default function Header() {
  const { pathname } = useLocation();
  const isHome = pathname === '/';
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // From sub-pages, anchors need to take you home first.
  const sectionLink = (anchor: string) => {
    if (isHome) return `#${anchor}`;
    if (anchor === 'about') return '/about';
    return `/#${anchor}`;
  };

  // Close mobile menu when navigating
  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container header__inner">
        <button
          className={`header__burger ${mobileMenuOpen ? 'header__burger--open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="header__burger-line"></span>
          <span className="header__burger-line"></span>
          <span className="header__burger-line"></span>
        </button>

        <Link to="/" className="header__brand" aria-label={`${site.name} — home`}>
          <span className="header__mark" aria-hidden="true">
            {site.initials}
          </span>
          <span className="header__name">{site.name}</span>
        </Link>

        <nav className="header__nav" aria-label="Primary">
          <a href={sectionLink('case-studies')}>Work</a>
          <Link to="/about">About</Link>
          <a href={sectionLink('contact')} className="header__cta">
            Get in touch
          </a>
        </nav>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <nav className="header__mobile-nav" aria-label="Mobile Navigation">
            <a href={sectionLink('case-studies')} onClick={handleNavClick}>
              Work
            </a>
            <Link to="/about" onClick={handleNavClick}>
              About
            </Link>
            <a href={sectionLink('contact')} onClick={handleNavClick} className="header__mobile-cta">
              Get in touch
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
